
document.addEventListener('DOMContentLoaded', () => {
    function updateButtonText() {
        const submitButton = document.querySelector('.custom-product-form__submit');
        if (submitButton) {
            const span = submitButton.querySelector('span');
            if (span) {
                const colorSwatchContainers = document.querySelectorAll('.product__info-wrapper .color_swatch__container');
                let comingSoonFound = false;

                colorSwatchContainers.forEach(container => {
                    const input = container.querySelector('input[type="radio"]');
                    if (input && input.checked && input.value.trim() === 'Knight Blue' && container.querySelector('.variant-coming-soon')) {
                        comingSoonFound = true;
                    }
                });

                if (comingSoonFound) {
                    span.textContent = 'Coming Soon';
                } else {
                    // span.textContent = 'Out Of Stock';
                }
            }
        }
    }

    function observeChanges() {
        const productInfoWrapper = document.querySelector('.product__info-wrapper');
        if (!productInfoWrapper) return;

        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' || mutation.type === 'childList') {
                    if (mutation.target.classList.contains('custom-product-form__submit')) {
                        updateButtonText();
                    }
                }
            });
        });

        observer.observe(productInfoWrapper, { attributes: true, childList: true, subtree: true });
    }

    updateButtonText();
    observeChanges();

    document.querySelectorAll('.product__info-wrapper .color_swatch__container').forEach(container => {
        container.addEventListener('click', () => {
            updateButtonText();
        });
    });
});











